import React from "react";

const FormContext = React.createContext({
  loader: () => Promise.resolve({}),
});

export default FormContext;
